/**
 * API Client Entry Point
 *
 * This file ensures that the API client is initialized with auth interceptors
 * before any API calls are made.
 */

import { createApiClient, setLanguageHeader } from './api-client';

// Initialize the API client with auth interceptors
// This must be called before any API functions are used
export const apiClient = createApiClient();

// Re-export utilities
export { setLanguageHeader };

// Re-export types and runtime enums from generated code
export * from './generated/types.gen';
